// Requests are shared for 60 seconds after success; failures retry on the next call.
const FLAG_KEYS = {
  landing_v2: 'mid_landing_v2',
  landing_chat: 'mid_landing_chat',
  buyer_profile_v2: 'mid_buyer_profile_v2',
  rental_mode: 'mid_rental_mode',
};
let publicFlagsPromise;
let publicFlagsExpiresAt = 0;
let publicFlagsPending = false;

export function readCachedPublicFlags() {
  try {
    const landingV2 = localStorage.getItem(FLAG_KEYS.landing_v2);
    if (landingV2 !== 'true' && landingV2 !== 'false') return null;
    return Object.fromEntries(Object.entries(FLAG_KEYS).map(([name, key]) => [name, localStorage.getItem(key) === 'true']));
  } catch {
    return null;
  }
}

export function loadPublicFlags(refresh = false) {
  if (publicFlagsPromise && (publicFlagsPending || (!refresh && Date.now() < publicFlagsExpiresAt))) return publicFlagsPromise;
  publicFlagsPending = true;
  const controller = new AbortController();
  publicFlagsPromise = new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      controller.abort();
      reject(new Error('Public flags timeout'));
    }, 8000);
    Promise.resolve()
      .then(() => fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/public/flags`, { signal: controller.signal }))
      .then((response) => response.ok ? response.json() : null)
      .then((flags) => {
        if (controller.signal.aborted) return;
        if (typeof flags?.landing_v2 !== 'boolean') throw new Error('Invalid landing flag');
        const loaded = Object.fromEntries(Object.keys(FLAG_KEYS).map((name) => [name, flags[name] === true]));
        try {
          Object.entries(FLAG_KEYS).forEach(([name, key]) => localStorage.setItem(key, String(loaded[name])));
        } catch {
          // Storage can be unavailable; the successful answer still applies.
        }
        publicFlagsExpiresAt = Date.now() + 60000;
        publicFlagsPending = false;
        resolve(loaded);
      })
      .catch(reject)
      .finally(() => clearTimeout(timer));
  }).catch(() => {
    publicFlagsPromise = undefined;
    publicFlagsPending = false;
    // `failed` separates "no answer" from a real off: a prerendered landing keeps itself on no answer.
    return readCachedPublicFlags() ?? { landing_v2: false, landing_chat: false, buyer_profile_v2: false, rental_mode: false, failed: true };
  });
  return publicFlagsPromise;
}
